import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';
import Billing from './billing';

const Organization = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/billing`} component={Billing} />

    <Route component={asyncComponent(() => import('app/routes/404'))} />
  </Switch>
);

export default Organization;
